export default "__VITE_ASSET__COrw0wwV__"